export default "__VITE_ASSET__3d17801b__"